import React from 'react'
import GenericTabs from '../../components/Tabs'
import { studentsAndFacultyTabs } from '../../consts/studentsAndFacultyTabs'
import FacultyAndStaff from '../../features/FacultyAndStaff'
import PageHeader from '../../components/PageHeader'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import { Box } from '@mui/material'
import ROUTES from '../../consts/paths'
import { type CustomBreadcrumbT } from '../../utils/BreadcrumbDataPreparation'

const Page = (): JSX.Element => {
  const breadcrumbPrefixList: CustomBreadcrumbT[] = [{
    title: 'Faculty & Staff',
    path: ROUTES.FACULTY_AND_STAFF
  }]
  return (
        <Box display='flex' flexDirection='column' gap={6}>
      <CustomHeader title={PAGE_TITLES.USERS} />
      <PageHeader title={PAGE_TITLES.USERS} breadcrumb={breadcrumbPrefixList} />
      <GenericTabs tabs={studentsAndFacultyTabs} />
      <FacultyAndStaff />
    </Box>
  )
}

export default Page
